import Dropdown from '~/components/Dropdown';
import {
  listaRelacaoPT,
  tipoPedidoPT,
  quemSouPT,
  segments,
  brands,
} from '../../helpers/texts';
import Input from '~/components/Input';
import InputFile from '~/components/InputFile';
import { Checkbox, Radio } from '@mui/material';
import Image from 'next/image';
import LanguageSelector from '~/components/LanguageSelector';
import { languages } from '~/helpers/constants';
import { RadioGroup } from '@headlessui/react';
import InputPhone from '~/components/InputPhone';
import Loading from '~/components/Loading';
import ReCAPTCHA from 'react-google-recaptcha';
import Modal from 'react-modal';
import useFormTools from '~/helpers/useFormTools';

Modal.setAppElement('#__next');

const Formulario: React.FC = () => {
  const {
    customStyles,
    submitForm,
    handleBrandsAndSegments,
    loading,
    warning,
    isModalOpen,
    handleCaptchaChange,
    formValues,
    handleForm,
    isEmployeeRelated,
    isSupplier,
    isNeededBrandAndSegments,
    emailRegex,
    isButtonEnabled,
    setIsModalOpen,
  } = useFormTools('pt');

  return (
    <div>
      <div className="h-[120px] w-full">
        <div className="m-auto flex h-full max-w-[968px] justify-between">
          <Image src="/Images/LOGO_PT.svg" alt="logo" width={250} height={75} />
          <LanguageSelector
            options={languages}
            className="my-auto"
            currentSelectedOption={languages[0]}
          />
        </div>
      </div>
      <div className="mx-auto max-w-[968px] px-3 pt-3">
        <h1 className="text-center text-[30px] font-semibold">
          Bem-vindo ao Canal Peipedê de Relacionamento com o Titular
        </h1>
        <h3 className="mt-5 text-sm">
          Aqui você pode exercer os seus direitos como Titular de dados
          pessoais, garantidos por todas as leis de privacidade e proteção de
          dados pessoais vigentes.
        </h3>
        <h2 className="mt-5 text-xl">
          Tem alguma dúvida sobre os direitos que a Lei garante?
        </h2>
        <p className="mt-2 text-sm">
          Acesse &quot;
          <a
            className="text-red-700"
            href="https://cdn.prod.website-files.com/69cb021343dbf125cabfa994/6a1de549a6559a96cdecfb0b_Aviso%20de%20PPD%20do%20site%20-%20s%C3%B3%20PT.pdf"
            target="_blank"
          >
            aqui
          </a>
          &quot; nosso
          <b>&nbsp;Aviso Privacidade e Proteção de Dados Pessoais&nbsp;</b>
          ou envie sua solicitação através do formulário abaixo.
        </p>
        <h2 className="mt-5 text-xl">Orientações Gerais:</h2>
        <p className="mt-2 text-sm">
          <ul className="ml-10 text-justify">
            <li style={{ listStyle: 'outside' }}>
              <b>Validação Identidade do Solicitante:</b>
              &nbsp; O prazo para resposta à sua solicitação será iniciado a
              partir da validação de sua identidade, respeitando os limites
              estabelecidos pela regulamentação aplicável. Na impossibilidade de
              validação, a Suzano entrará em contato com você através dos meios
              aqui disponibilizados, e se dentro de 07 (sete) dias não
              obtivermos retorno, a solicitação será encerrada. Por conta disso,
              lembre-se de inserir o seu melhor e-mail para contato.
            </li>
            <li className="mt-1" style={{ listStyle: 'outside' }}>
              <b>Como acompanhar a solicitação:</b>
              &nbsp; Você receberá, via e-mail lgpd@suzano.com.br, um
              identificador único (ID) após finalizar sua solicitação. Caso
              queira informações sobre o status da sua requisição, nos encaminhe
              um e-mail informando o número do ID. Além disso, entraremos em
              contato sempre que houver atualizações em seu pedido.
            </li>
          </ul>
        </p>
        {/* inicio form */}
        <div className="mt-10 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            DIREITOS DOS TITULARES DE DADOS
          </h1>
        </div>
        <p className="my-10 text-sm">
          Selecione o tipo de solicitação (Obrigatório)
        </p>

        <div className="mt-2">
          <div className="font-semibold">Você gostaria de? *</div>
          <Dropdown
            label="Defina qual é o seu pedido"
            options={tipoPedidoPT}
            currentSelectedOption={
              tipoPedidoPT.filter(tipo => tipo.name === formValues.request)[0]
            }
            warning={warning && formValues.request === ''}
            onChange={value => handleForm('request', value?.target as string)}
          />
        </div>

        <div className="mt-2">
          <div className="font-semibold">Detalhes de sua solicitação *</div>
          <textarea
            className={`w-full rounded-md border-2 
            ${
              warning && formValues.requestDetail === ''
                ? 'border-erro-bordocaulequente50'
                : 'border-neutra3-cinzaquente70 '
            }
            text-sm text-neutra3-cinzaquente10 focus:border-neutra3-cinzaquente50 focus:ring-0`}
            name="descricao"
            id=""
            cols={30}
            rows={3}
            value={formValues.requestDetail}
            onChange={event => handleForm('requestDetail', event.target.value)}
          />
        </div>

        <div className="my-4 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            IDENTIFICAÇÃO DO REQUISITANTE
          </h1>
        </div>

        <RadioGroup value={formValues.iAm} onChange={e => handleForm('iAm', e)}>
          <RadioGroup.Label
            className={`${
              warning && formValues.iAm === ''
                ? 'text-erro-bordocaulequente50'
                : 'text-black'
            } font-semibold`}
          >
            Eu sou: *
          </RadioGroup.Label>
          {quemSouPT.map(item => (
            <RadioGroup.Option value={item.name} key={item.name}>
              {({ checked }) => (
                <span className="flex items-center">
                  <Radio
                    size="small"
                    checked={checked}
                    sx={{
                      color: warning && formValues.iAm === '' ? '#DA253F' : '',
                      '&.Mui-checked': {
                        color: '#1932C8',
                      },
                    }}
                  />
                  {item.name}
                </span>
              )}
            </RadioGroup.Option>
          ))}
        </RadioGroup>
        {formValues.iAm === 'Representante Legal' && (
          <ul className="ml-10 text-justify">
            <li className="mt-1" style={{ listStyle: 'outside' }}>
              Se o seu pedido envolve dados pessoais de outra pessoa, você deve
              nos fornecer uma procuração, com assinatura autenticada, que o
              autoriza a exercer os direitos em nome deste Titular dos Dados,
              bem como adicionar a cópia do documento do solicitante terceiro a
              este pedido.
            </li>
            <li className="mt-1" style={{ listStyle: 'outside' }}>
              Se o seu pedido envolve dados de um menor, você deve adicionar uma
              cópia do documento do menor e um documento, com validade
              autenticada, que comprove a responsabilidade pelo menor a este
              pedido.
            </li>
          </ul>
        )}

        <div className="mt-2">
          <div className="font-semibold">Minha relação com a Suzano</div>
          <Dropdown
            label="Especifique sua relação com a Suzano"
            options={listaRelacaoPT}
            currentSelectedOption={
              listaRelacaoPT.filter(
                tipo => tipo.name === formValues.relation,
              )[0]
            }
            warning={warning && formValues.relation === ''}
            onChange={value => handleForm('relation', value?.target as string)}
          />
        </div>

        <div>
          {isEmployeeRelated && (
            <div className="my-4 flex gap-8 bg-primaria-azulsuzano80 px-8 py-6">
              <div className="w-full">
                <div className="font-semibold">Se for colaborador *</div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.np === ''}
                  value={formValues.np}
                  placeholder="Insira seu NP xxxx"
                  onChange={event => handleForm('np', event.target.value)}
                />
              </div>
              <div className="w-full">
                <div className="font-semibold">Insira seu e-mail *</div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.suzano_mail === ''}
                  value={formValues.suzano_mail}
                  placeholder="Insira seu e-mail @suzano"
                  onChange={event =>
                    handleForm('suzano_mail', event.target.value)
                  }
                />
              </div>
            </div>
          )}
          {isSupplier && (
            <div className="my-4 flex gap-8 bg-primaria-azulsuzano80 px-8 py-6">
              <div className="w-full">
                <div className="font-semibold">
                  Se for Fornecedor ou Prestador de Serviço *
                </div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.supplier === ''}
                  value={formValues.supplier}
                  placeholder="Insira seu NP de Terceiro ou Código de Fornecedor (SAP)"
                  onChange={event => handleForm('supplier', event.target.value)}
                />
              </div>
              <div className="w-full">
                <div className="font-semibold">Insira seu e-mail *</div>
                <Input
                  style="w-full bg-white"
                  warning={warning && formValues.corp_mail === ''}
                  value={formValues.corp_mail}
                  placeholder="Insira seu e-mail corporativo"
                  onChange={event =>
                    handleForm('corp_mail', event.target.value)
                  }
                />
              </div>
            </div>
          )}
          {isNeededBrandAndSegments && (
            <div className="my-4">
              <h2>
                Selecione os segmentos e marcas que processaram seus dados
              </h2>
              <div className="grid grid-cols-2 bg-primaria-azulsuzano90 px-8 py-6">
                <div className="col-span-1 flex flex-col">
                  <h2 className="mb-1 font-semibold">
                    Especifique os segmentos *
                  </h2>
                  {segments.map(segment => (
                    <span key={segment}>
                      <input
                        type="checkbox"
                        id={segment}
                        checked={formValues.segments.includes(segment)}
                        className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                        onClick={() =>
                          handleBrandsAndSegments('segments', segment)
                        }
                      />
                      <label htmlFor={segment}>{segment}</label>
                    </span>
                  ))}
                  <span>
                    <input
                      id="other segment"
                      type="checkbox"
                      checked={formValues.segments.includes('Outros')}
                      className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                      onClick={() =>
                        handleBrandsAndSegments('segments', 'Outros')
                      }
                    />
                    <label htmlFor="other segment">Outros</label>
                  </span>
                </div>
                <div className="col-span-1 flex flex-col">
                  <h2 className="mb-1 font-semibold">
                    Especifique as marcas *
                  </h2>
                  {brands.map(brand => (
                    <span key={brand}>
                      <input
                        type="checkbox"
                        id={brand}
                        checked={formValues.brands.includes(brand)}
                        className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                        onClick={() => handleBrandsAndSegments('brands', brand)}
                      />
                      <label htmlFor={brand}>{brand}</label>
                    </span>
                  ))}
                  <span>
                    <input
                      id="other brand"
                      type="checkbox"
                      checked={formValues.brands.includes('Outros')}
                      className="me-1 rounded checked:bg-primaria-azulsuzano50 focus:ring-0"
                      onClick={() =>
                        handleBrandsAndSegments('brands', 'Outros')
                      }
                    />
                    <label htmlFor="other brand">Outros</label>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-2">
          <div className="font-semibold">Nome completo *</div>
          <Input
            style="w-full"
            warning={warning && formValues.fullName === ''}
            value={formValues.fullName}
            placeholder="Insira o 'Nome completo' do titular dos dados de acordo com seu documento de identidade"
            onChange={event => handleForm('fullName', event.target.value)}
          />
        </div>

        <div className="mt-10 flex w-full gap-10">
          <span className="w-full">
            <div className="font-semibold">Número do celular</div>
            <InputPhone
              style="w-full"
              onChange={handleForm}
              value={formValues.cellNumber}
            />
          </span>
          <span className="w-full">
            <div className="font-semibold">Endereço de email (Notificação)</div>
            <Input
              type="email"
              style="w-full"
              warning={
                formValues.eMail !== '' && !emailRegex.test(formValues.eMail)
              }
              value={formValues.eMail}
              placeholder="Seu melhor email para ser notificado referente à esta requisição"
              onChange={event => handleForm('eMail', event.target.value)}
            />
          </span>
        </div>
        <div className="mt-10 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            VERIFICAÇÃO DE IDENTIDADE
          </h1>
        </div>

        <p className="mt-3 text-justify text-sm">
          Para atender a sua requisição e garantir a segurança dos seus dados
          pessoais, a Suzano realiza a verificação de sua identidade.
          <br />
          <br />
          Para fazer isso o mais rápido possível e de maneira segura, você deve
          anexar uma “imagem | foto | selfie”, segurando um documento de
          identificação com foto, de maneira que as informações do documento
          estejam legíveis para fins de validação. <br />
          <br />
          Documentos de Identificação admitidos: <br />
          <br />
          <ul className="ml-10">
            <li style={{ listStyle: 'outside' }}>
              Registro Geral (RG) contendo o número do Cadastro de Pessoas
              Físicas (CPF);
            </li>
            <li style={{ listStyle: 'outside' }}>
              Carteira Nacional de Habilitação (CNH) contendo o número do
              Cadastro de Pessoas Físicas (CPF);
            </li>
          </ul>
          <br />
          Se no momento da validação da sua identidade resultar em alguma
          inconsistência, a Suzano entrará em contato por meio do e-mail
          registrado para solicitar informações adicionais.
        </p>
        <div className="relative">
          <InputFile
            label="Clique para carregar sua foto *"
            accept="image/*"
            style="mt-3"
            className=""
            multiple
            onChange={event => handleForm('photo', event.target.files[0])}
          />
          {warning && formValues.photo === null && (
            <p className="absolute bottom-[-16px] text-xs text-erro-bordocaulequente50">
              Por favor, carregue a imagem do documento
            </p>
          )}
          {formValues.photo !== null && (
            <p className="absolute bottom-[-16px] text-xs text-primaria-azulsuzano50">
              {formValues.photo.name}
            </p>
          )}
        </div>

        <div className="mt-10 flex h-[40px] bg-[#333333]">
          <h1 className="m-auto text-xl font-semibold text-white">
            AVISO DE PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS
          </h1>
        </div>
        <p className="mt-3 text-justify text-sm">
          Nós valorizamos a sua privacidade e a proteção de dados pessoais,
          portanto, as suas informações serão tratadas pela Suzano, de acordo
          com as disposições do nosso{' '}
          <b>Aviso Privacidade e Proteção de Dados Pessoais.</b>
        </p>
        <div className="mt-3 flex">
          <Checkbox
            checked={formValues.authorize}
            sx={{
              color: warning && !formValues.authorize ? '#DA253F' : '',
              '&.Mui-checked': {
                color: '#1932C8',
              },
            }}
            onChange={event => handleForm('authorize', event.target.checked)}
          />
          <div className="text-sm">
            AUTORIZO a Suzano a tratar meus dados pessoais e/ou os dados
            pessoais daquele que represento, para os fins e nas formas descritas
            acima. Ao submeter esta requisição e os dados pessoais solicitados,
            declaro para os devidos fins que sou maior de idade e/ou responsável
            pelos meus dependentes menores.
          </div>
        </div>
        <div className="relative mt-5 flex justify-center">
          <button
            className="mb-10 rounded-md bg-secundaria-verdebroto50 p-3 font-semibold text-white disabled:cursor-not-allowed disabled:bg-secundaria-verdefolha50 disabled:text-neutra3-cinzaquente50"
            disabled={!formValues.authorize}
            onClick={submitForm}
          >
            Enviar Solicitação
          </button>
          {warning && !isButtonEnabled && (
            <p className="absolute bottom-3 rounded-md bg-erro-bordocaulequente50 px-2 py-1 text-xs font-semibold text-white">
              Por favor, preencha corretamente todos os campos necessários
            </p>
          )}
        </div>
      </div>
      {loading && <Loading />}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        style={customStyles}
      >
        <h2 className="mb-4 mt-9">Por favor, complete o reCAPTCHA</h2>
        <ReCAPTCHA
          sitekey="6Lckr0UqAAAAAFFeywsJEB-jsKp5D0mUUaAx8uTA"
          onChange={handleCaptchaChange}
        />
      </Modal>
    </div>
  );
};

export default Formulario;
